import { Component, OnInit, Input, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ListColumn } from 'src/@fury/shared/list/list-column.model';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { HttpResponse } from '@angular/common/http';
import { Location } from '@angular/common';


@Component({
  selector: 'fury-optional-item-details',
  templateUrl: './optional-item-details.component.html',
  styleUrls: ['./optional-item-details.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class OptionalItemDetailsComponent implements OnInit {

  @Input()
  columns: ListColumn[] = [ { name: 'Name', property: 'title', visible: true } ] as ListColumn[];
  dataSource!: MatTableDataSource<any> | null;
  itemList: any[]= []; filterValue: any;
  imageBasePath!: string; selection: any[]= [];
  detailData: any; categoryId: any;
  constructor(
    private apiservice: ApiService, private router: Router,
    private cdr: ChangeDetectorRef, private activatedroute: ActivatedRoute,
    public location: Location
  ) { this.filterValue = 'Assigned Items' }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }
  ngOnInit(): void {
    this.activatedroute.params.subscribe((res: any) => {
      if(res.id) {
        this.categoryId = res.id; this.getdetail(this.categoryId);
      } else {
        this.location.back();
      }
    });
  }

  getdetail(categoryId: string) {
    this.apiservice.get(`admin/plan/optional-item-category/get-optional-item-category/${categoryId}`)
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.status === 200) {
            this.itemList = res.body.planOptionalItemCategory.coveredItems;
            this.dataSource = new MatTableDataSource(this.itemList); this.cdr.detectChanges();
          }
        }
      });
  }

  back() {
    this.location.back();
  }

}
